// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as HomeBannerTextModuleScss from "../styles/HomeBannerText.module.scss";

var styles = HomeBannerTextModuleScss;

function HomeBannerTextCmp(Props) {
  var title = Props.title;
  var description = Props.description;
  return React.createElement("div", {
              className: styles["banner-wrapper"]
            }, React.createElement("h1", {
                  className: styles["banner-subtext"]
                }, description), React.createElement("h1", {
                  className: styles["banner-text"]
                }, title));
}

var make = HomeBannerTextCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
